import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import SyncBars from '../components/SyncBars';

export default function NotFound() {
  return (
    <section className="relative min-h-[80vh] flex items-center justify-center overflow-hidden bg-surface px-4">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bloom rounded-full blur-3xl pointer-events-none" />
      <div className="relative z-10 text-center">
        <SyncBars count={6} className="h-8 mx-auto mb-8 justify-center opacity-60" />
        <p className="eyebrow text-purple-500 mb-4">// error 404</p>
        <h1 className="font-display text-6xl sm:text-7xl font-bold text-strong mb-4">
          Out of <span className="ink-grad">sync.</span>
        </h1>
        <p className="text-soft max-w-md mx-auto mb-9">
          The page you're looking for doesn't exist or has moved. Let's get you back on track.
        </p>
        <Link to="/">
          <Button
            size="lg"
            className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-8 py-6 rounded-xl transition-all duration-300 hover:scale-105 shadow-lg shadow-purple-500/30 group"
          >
            <ArrowLeft className="mr-2 w-5 h-5 group-hover:-translate-x-1 transition-transform" />
            Back home
          </Button>
        </Link>
      </div>
    </section>
  );
}
